import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FieldAgentClient, SalesArea } from 'ep-bt-field-agent-proxy';

@Component({
  selector: 'epbt-fa-salesarea-list',
  templateUrl: './epbt-fa-salesarea-list.component.html',
  styleUrls: ['./epbt-fa-salesarea-list.component.scss']
})
export class EpbtFaSalesareaListComponent implements OnInit {

  @Input() salesAreas: any;
  @Input() readonly: boolean;


  @Input() selectedSalesAreaId: SalesArea;

  @Output() selectedSalesAreaIdChange = new EventEmitter<any>();

  constructor(private client: FieldAgentClient) { }

  ngOnInit(): void {
    this.GetSalesArea();
  }

  onSelectionChange(selectedValue: any) {
    this.selectedSalesAreaId = selectedValue;
    this.selectedSalesAreaIdChange.emit(this.selectedSalesAreaId);
  }

  GetSalesArea() {
    this.client.getBisTrackActiveSalesAreas().subscribe(res => {
      this.salesAreas = res;
      if (this.salesAreas.length > 0) {
        this.selectedSalesAreaId = this.salesAreas[0];
        this.selectedSalesAreaIdChange.emit(this.salesAreas[0]);
      }
    });
  }
}
